<template>
    <div>
      <Myhead></Myhead>
      <router-view/>
      <Myfoot></Myfoot>
    </div>
</template>
<script>
import Myhead from './components/Myhead'
import Myfoot from "./components/Myfoot";
export default {
  components:{
    Myhead,
    Myfoot
  }
}
</script>
<style>
body,p,ul,ol,pre,h3,h4,h2{
  margin: 0;
  padding: 0;
}
body{
  min-width: 1200px;
}
a{
  text-decoration:none;
  color: black;
}
ul,li{
  list-style: none;
}
body{
  font-family: '微软雅黑'
}
</style>
